export default "__VITE_ASSET__DjyFrjow__"